import { paths } from '@/constants/paths'
import { Seo, getBasicPageMetaData } from '@/layout/Seo'
import { NextPageWithLayout, PIFExplainerLayout } from '@/layouts'
import { MarketingVideoPopup } from '@/organisms/MarketingVideoPopup'
import { getPifProjects } from '@/services/PifService'
import { Project } from '@/services/ProjectsService'
import { getGenericStaticPaths } from '@/utils/GetGenericStaticPaths'
import { getStaticPropsErrorHandler } from '@/utils/nextUtils/nextErrorHandlers'
import { useTranslate } from '@/utils/translate/translate-client'
import { loadTranslations } from '@/utils/translate/translate-server'
import { PifExplainerView } from '@/views/PifExplainerView/PifExplainerView'

interface PayItForwardExplainerProps {
  locale: string
  projects: Project[]
}

export const PayItForwardExplainer: NextPageWithLayout<PayItForwardExplainerProps> = ({ locale, projects }) => {
  const { t } = useTranslate('pif')
  return (
    <>
      <Seo
        {...getBasicPageMetaData({
          cloudinaryImagePath: 'v1706828895/angel-studios/pif/Meta_Data_Image_-_PIF_Explainer.png',
          cloudinaryTransformation: 'b_rgb:000000',
          description: t(
            'angelStudiosPifMetaDescriptionV3',
            `Pay it Forward empowers fans to allow other people to receive free movie tickets and stream movies and shows online`,
          ),
          locale,
          path: paths.payItForward.index,
          title: t('angelStudiosPifMetaTitleV2', 'Pay it Forward | Angel Studios'),
        })}
      />
      <MarketingVideoPopup />
      <PifExplainerView projects={projects} />
    </>
  )
}

export const getStaticProps = getStaticPropsErrorHandler(
  { filePath: 'pages/[locale]/pay-it-forward/index.tsx' },
  async ({ locale }) => {
    const projects = await getPifProjects()

    return {
      props: {
        locale,
        projects,
        ...(await loadTranslations(locale, ['common', 'pif', 'account'])),
      },
    }
  },
)

PayItForwardExplainer.getLayout = (page) => {
  return <PIFExplainerLayout>{page}</PIFExplainerLayout>
}

export const getStaticPaths = getGenericStaticPaths

export default PayItForwardExplainer
